<template>
  <tr class="row sticky-header">
    <th class="cell tripnum">
      #
    </th>
    <th class="cell stock">
      <div>
        <div class="left">Stock # <input id="stock_search" style="color:black;" type="search" v-model="stock_number" placeholder="Search"><span @click="clearStock()" class="clear_x">X</span></div>
      </div>
    </th>
    <th class="cell driver">
      <div>
        <div class="left">
          {{driverText}}
        </div>
        <span class="dropdown">
          <i class="fa fa-bars"></i>
          <div class="menu">
            <label class="stack">
              <input type='radio' name='StatusTabGroup' value="all" v-model="driver">
              <span class="button toggle">All</span>
            </label>
            <label class="stack">
              <input type='radio' name='StatusTabGroup' value="has_driver" v-model="driver">
              <span class="button toggle">Assigned</span>
            </label>
            <label class="stack">
              <input type='radio' name='StatusTabGroup' value="needs_driver" v-model="driver">
              <span class="button toggle">Unassigned</span>
            </label>
          </div>
        </span>
      </div>
    </th>
    <th class="cell from">
      <div>
        <div class="left">
          From {{fromText}}
        </div>
          <span class="dropdown">
            <i class="fa fa-bars"></i>
            <div class="menu">
              <label for="tab-all-location-from" class="stack">
                <input id='tab-all-location-from' type='radio' value="all" v-model="from">
                <span class="button toggle">All</span>
              </label>
              <template v-for="location in locations">
                <label :for="`tab-${location.id}-location-from`" class="stack">
                  <input :id="`tab-${location.id}-location-from`" type='radio' :value="location.id" v-model="from">
                  <span class="button toggle">{{location.name}}</span>
                </label>
              </template>
            </div>
          </span>
      </div>
    </th>
    <th class="cell transitStatus">
        <div>
            <div class="left">
                Status
            </div>
        </div>
    </th>
    <th class="cell to">
      <div>
        <div class="left">
          To {{toText}}
        </div>
        <span class="dropdown">
          <i class="fa fa-bars"></i>
          <div class="menu">
            <label for="tab-all-location-to" class="stack">
              <input id='tab-all-location-to' type='radio' value="all" v-model="to">
              <span class="button toggle">All</span>
            </label>
            <template v-for="location in locations">
              <label :for="`tab-${location.id}-location-to`" class="stack">
                <input :id="`tab-${location.id}-location-to`" type='radio' :value="location.id" v-model="to">
                <span class="button toggle">{{location.name}}</span>
              </label>
            </template>
          </div>
        </span>
      </div>
    </th>
    <th class="cell details">Guest Waiting</th>
    <th class="cell notes">Notes</th>
  </tr>
</template>

<style scoped lang="less">
.clear_x {
    display: none;
    text-align: center;
    border: none;
    position: relative;
    width: 30px;
    border-radius: 20px;
    left: -34px;
    background-color: #ddd;
    padding: 2px;
    margin: 0px;
    color:red;
}
#stock_search:not(:placeholder-shown)+ .clear_x
{
  display:inline-block;
}
  
  
th > div {
  display: flex;
  justify-content: space-between;
  .left {
    white-space: nowrap;
  }
}
.sticky-header th {
  position: sticky;
  top: 0;
  z-index: 3;
}
.dropdown {
  float: right;
  position: relative;
  width: 2em;
  text-align: right;
}
div.menu {
  position: absolute;
  right: 0;
  display: none;
  border: 1px solid white;
  .button {
    border-bottom: 1px solid white;
  }
}
.dropdown:hover div.menu,
div.menu:hover {
  display: block;
}
@media (max-width: 1270px) {
  tr {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    th {
      flex-grow: 1;
    }
  }
  .cell.tripnum,
  .cell.stock,
  .cell.details,
  .cell.notes {
    display: none;
  }
  .cell.driver,
  .cell.from,
  .cell.to {
    width: 30%;
  }
}
</style>

<script>
export default {
  data () {
    return {
      from: 'all',
      to: 'all',
      driver: 'all',
      stock_number:'',
    }
  },
  computed: {
    locations () {
      return this.$privateReactiveStore.locations
    },
    fromText () {
      let result = this.locations.filter(x => x.id === this.from)
      if (result.length === 0) return 'All'
      return result[0].name
    },
    toText () {
      let result = this.locations.filter(x => x.id === this.to)
      if (result.length === 0) return 'All'
      return result[0].name
    },
    driverText () {
      if (this.driver === 'has_driver') return 'Assigned Driver'
      if (this.driver === 'needs_driver') return 'Unassigned Driver'
      return 'Driver'
    }
  },
  methods:{
    clearStock()
    {
      this.stock_number=''
    }
  },
  watch: {
    from () {
      this.$emit('from', this.from)
    },
    to () {
      this.$emit('to', this.to)
    },
    driver () {
      this.$emit('driver', this.driver)
    },
    stock_number () {
      this.$emit('stock_number', this.stock_number)
    }
  }
}
</script>